import { MasterApiKeyStatus } from '../util/Types/MasterApiKey';
import { ApiService } from './ApiService';

export class MasterApiKeyService extends ApiService {
  static pathName = '/internal/master-api-key';

  static getStatus = (): Promise<MasterApiKeyStatus> => {
    return ApiService.get(`${this.pathName}`);
  };

  static rotate = (): Promise<{ apiKey: string }> => {
    return ApiService.post(`${this.pathName}/rotate`);
  };
}
